<template>
  <a-modal
    title="个性化设置"
    :maskClosable="false"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :cancelText="'取消'"
    :okText="'确定'"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-form layout="horizontal" class="form">
      <!-- 站点Logo -->
      <a-form-item
        label="站点Logo"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-select
          class="form-cell"
          placeholder="请选择"
          v-model="select.siteShowType"
          @change="change_siteShowType"
        >
          <a-select-option v-for="item in selectOption" :value="item.value" :key="item.value">{{
            item.key
          }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item
        label="自定义上传"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
        v-if="select.siteShowType == '2'"
      >
        <c-upload
          accept="image/*"
          ossType="avatar"
          :isSingle="true"
          @uploadSuccess="success_siteLogoUrl"
          :sourceFileList="siteLogoUrlList"
        ></c-upload>
        <div class="desc">建议尺寸：150*48， 仅支持jpg、png格式</div>
      </a-form-item>

      <!-- 教育局管理端logo -->
      <a-form-item
        label="教育局管理端logo"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-select
          class="form-cell"
          placeholder="请选择"
          v-model="select.bureauShowType"
          @change="change_bureauShowType"
        >
          <a-select-option v-for="item in selectOption" :value="item.value" :key="item.value">{{
            item.key
          }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item
        label="自定义上传"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
        v-if="select.bureauShowType == '2'"
      >
        <c-upload
          accept="image/*"
          ossType="avatar"
          :isSingle="true"
          @uploadSuccess="success_bureauLogoUrl"
          :sourceFileList="bureauLogoUrlList"
        ></c-upload>
        <div class="desc">建议尺寸：150*48， 仅支持jpg、png格式</div>
      </a-form-item>

      <!-- 学校管理端logo -->
      <a-form-item
        label="学校管理端logo"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-select
          class="form-cell"
          placeholder="请选择"
          v-model="select.schoolShowType"
          @change="change_schoolShowType"
        >
          <a-select-option v-for="item in selectOption" :value="item.value" :key="item.value">{{
            item.key
          }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item
        label="自定义上传"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
        v-if="select.schoolShowType == '2'"
      >
        <c-upload
          accept="image/*"
          ossType="avatar"
          :isSingle="true"
          @uploadSuccess="success_schoolLogoUrl"
          :sourceFileList="schoolLogoUrlList"
        ></c-upload>
        <div class="desc">建议尺寸：150*48， 仅支持jpg、png格式</div>
      </a-form-item>

      <!-- 课程方管理端logo -->
      <a-form-item
        label="课程方管理端logo"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-select
          class="form-cell"
          placeholder="请选择"
          v-model="select.institutionShowType"
          @change="change_institutionShowType"
        >
          <a-select-option v-for="item in selectOption" :value="item.value" :key="item.value">{{
            item.key
          }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item
        label="自定义上传"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
        v-if="select.institutionShowType == '2'"
      >
        <c-upload
          accept="image/*"
          ossType="avatar"
          :isSingle="true"
          @uploadSuccess="success_institutionLogoUrl"
          :sourceFileList="institutionLogoUrlList"
        ></c-upload>
        <div class="desc">建议尺寸：150*48， 仅支持jpg、png格式</div>
      </a-form-item>

      <!-- 站点推荐课程模块 -->
      <a-form-item
        label="站点推荐课程模块"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-switch v-model="courseShow" />
      </a-form-item>

      <!-- 站点底部公司介绍模块 -->
      <!-- <a-form-item
        label="站点底部公司介绍模块"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-switch v-model="siteBottomShow" />
      </a-form-item> -->

      <!-- 课程方管理端logo -->
      <a-form-item
        label="站点底部公司介绍模块"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-select class="form-cell" placeholder="请选择" v-model="select.siteBottomShow">
          <a-select-option v-for="item in selectOption" :value="item.value" :key="item.value">{{
            item.key
          }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item
        label="自定义上传"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
        v-if="select.siteBottomShow == '2'"
      >
        <c-upload
          accept="image/*"
          ossType="avatar"
          :isSingle="true"
          @uploadSuccess="success_siteBottomLogoUrl"
          :sourceFileList="siteBottomLogoUrl"
        ></c-upload>
        <div class="desc">仅支持jpg、png格式</div>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import bureau from "../../../api/bureau";

import CUpload from "../../../components/CUpload";

export default {
  name: "bureauFormModal",
  data() {
    return {
      visible: false,
      confirmLoading: false,
      updateData: {},
      selectOption: [
        { key: "平台默认", value: 1 },
        { key: "自定义", value: 2 },
        { key: "不显示", value: 3 },
      ],
      siteLogoUrlList: [], //头像回显
      bureauLogoUrlList: [], //头像回显
      schoolLogoUrlList: [], //头像回显
      institutionLogoUrlList: [], //头像回显
      siteBottomLogoUrl: [], //站点底部分公司介绍模块是否显示
      select: {
        siteShowType: 1,
        bureauShowType: 1,
        schoolShowType: 1,
        institutionShowType: 1,
        siteBottomShow: 1,
        siteLogoUrl: "",
        schoolLogoUrl: "",
        institutionLogoUrl: "",
        bureauLogoUrl: "",
        siteBottomLogoUrl: "",
      },
      courseShow: true, //1显示 0不显示 站点推荐课程模块是否显示
    };
  },
  components: {
    CUpload,
  },
  methods: {
    change_siteShowType(val) {
      val != 3 ? (this.select.siteLogoUrl = "") : "";
    },
    change_bureauShowType(val) {
      val != 3 ? (this.select.bureauLogoUrl = "") : "";
    },
    change_schoolShowType(val) {
      val != 3 ? (this.select.schoolLogoUrl = "") : "";
    },
    change_institutionShowType(val) {
      val != 3 ? (this.select.institutionLogoUrl = "") : "";
    },
    change_siteBottomShow(val) {
      this.select.siteBottomShow = val;
      if (val !== 3) {
        this.select.siteBottomShow = "";
      }
    },

    //封面上传成功之后回调
    success_siteLogoUrl(url) {
      this.select.siteLogoUrl = url;
    },

    //封面上传成功之后回调
    success_schoolLogoUrl(url) {
      this.select.schoolLogoUrl = url;
    },

    //封面上传成功之后回调
    success_institutionLogoUrl(url) {
      this.select.institutionLogoUrl = url;
    },

    //封面上传成功之后回调
    success_siteBottomLogoUrl(url) {
      this.select.siteBottomLogoUrl = url;
    },

    //封面上传成功之后回调
    success_bureauLogoUrl(url) {
      this.select.bureauLogoUrl = url;
    },

    //初始化，显示
    init(params) {
      this.visible = true;

      // //初始化form表单数据
      if (params) {
        console.log(params);
        this.updateData = params;
        let _tempData = {
          siteShowType: params.siteShowType,
          bureauShowType: params.bureauShowType,
          schoolShowType: params.schoolShowType,
          institutionShowType: params.institutionShowType,
          siteLogoUrl: params.siteLogoUrl,
          schoolLogoUrl: params.schoolLogoUrl,
          institutionLogoUrl: params.institutionLogoUrl,
          bureauLogoUrl: params.bureauLogoUrl,
          siteBottomShow: params.siteBottomShow,
          siteBottomLogoUrl: params.siteBottomLogoUrl,
        };
        this.select = _tempData;
        this.courseShow = params.courseShow == "1";
        this.siteLogoUrlList = [params.siteLogoUrl]; //头像回显
        this.bureauLogoUrlList = [params.bureauLogoUrl]; //头像回显
        this.schoolLogoUrlList = [params.schoolLogoUrl]; //头像回显
        this.institutionLogoUrlList = [params.institutionLogoUrl]; //头像回显
        this.siteBottomLogoUrl = [params.siteBottomLogoUrl]; //头像回显
        console.log(this.siteBottomLogoUrl);
      }
    },

    //隐藏
    handleCancel() {
      this.visible = false;
      this.$emit("closeForm");
    },

    //提交表单
    handleSubmit(e) {
      e.preventDefault();
      let req = Object.assign({}, this.select);
      req.courseShow = this.courseShow ? "1" : "0";
      this.settingServer(req);
    },

    /**
     * 个性化设置接口调用
     */
    settingServer(value) {
      console.log(value);
      bureau.setting(this.updateData.id, value).then(res => {
        this.$message.success("设置成功");
        this.handleCancel();
        this.$emit("updateBureau", res.data);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "src/config/var";
.form {
  height: calc(100vh - 360px);
  overflow-y: auto;
}
.desc {
  font-size: 12px;
  color: #909399;
  line-height: 20px;
}
</style>
